<mat-card>
  <mat-card-title
    >Informações e procedimentos a serem realizados pelo docente responsável por disciplina</mat-card-title
  >
  <mat-card-content>
    <ol>
      <li>
        Fazer o lançamento da carga horária efetiva ao aluno no SISPAADES ao termino da oferta.<br /><i
          >(Obs: Somente disponível se o aluno lançou a carga horária prevista no SISPAADES, como também o aluno estar
          vinculado na oferta da disciplina no SISGRAD)</i
        >.
      </li>
      <li>
        Aprovar relatório do aluno sobre a responsabilidade do docente.<br /><i
          >(Obs: Somente depois de realizado o primeiro item).</i
        >
      </li>
      <li>
        Emissão do certificado de participação no PAADES para o docente responsável por disciplina.<br /><i
          >(Obs: Somente após itens 1 e 2 realizados e a homolgação do relatório do aluno realizado pelo chefe do
          Departamento).</i
        >
      </li>
    </ol>
  </mat-card-content>
</mat-card>
